var map = {
	"./LOGO-100.png": "b41b",
	"./LOGO-500.png": "d3d3",
	"./LOGOI.png": "3ebc",
	"./LOGOS-100x100.png": "f622",
	"./LOGOS-138x40.png": "2bc6",
	"./LOGOS-152x24.png": "31b2",
	"./LOGOS.png": "2865",
	"./logo-100x100.png": "db44",
	"./logo-150x150.png": "fa27",
	"./logo-192x192.png": "f5f0",
	"./logo-200x200.png": "d962",
	"./logo-512x512.png": "bb6d",
	"./logo-800x800.png": "bb64",
	"./s1-logo.png": "b29a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dfa2";